import { I18n } from '@/services/i18n';

type Message = {
  getPremium: string;
  activate: string;
  discount0: string;
  discount35: string;
  discount50: string;
  authorizationFee: string;
  paySafe: string;
};

const messages: I18n<Message> = {
  en: {
    discount0: 'Become Premium',
    discount35: 'GET -35% PREMIUM',
    discount50: 'GET -50% PREMIUM',
    getPremium: '{discount}',
    activate: 'Activate Premium',
    authorizationFee:
      'By continuing, you agree that a nominal {price} may be charged and immediately refunded as part of account and payment setup. This transaction does not represent any additional cost and is processed solely to initialize your payment method.',
    paySafe: 'Pay safe and secure',
  },
  es: {
    discount0: 'Obtenga Premium',
    discount35: 'OBTENER -35% PREMIUM',
    discount50: 'OBTENER -50% PREMIUM',
    getPremium: '{discount}',
    activate: 'Activate Premium',
    authorizationFee:
      'Al continuar, acepta que se puede cobrar un {price} nominal y reembolsarlo inmediatamente como parte de la configuración de la cuenta y el pago. Esta transacción no representa ningún costo adicional y se procesa únicamente para inicializar su método de pago.',
    paySafe: 'Pague seguro y seguro',
  },
  de: {
    discount0: 'Premium erhalten',
    discount35: 'GET -35% PREMIUM',
    discount50: 'GET -50% PREMIUM',
    getPremium: '{discount}',
    activate: 'Premium aktivieren',
    authorizationFee:
      'Durch Fortfahren stimmen Sie zu, dass ein nomineller {price} belastet und sofort erstattet werden kann als Teil der Konto- und Zahlungseinrichtung. Diese Transaktion stellt keine zusätzlichen Kosten dar und wird ausschließlich zur Initialisierung Ihrer Zahlungsmethode verarbeitet.',
    paySafe: 'Sicher und sicher zahlen',
  },
};

export { messages };
